import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import NProgress from "nprogress";

export const GetVMExtraSettingConfigHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/visitors/getVMExtraSettingConfig`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: params?.domain ? params?.domain : getDomain(),
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Configuration Retrived Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
       NProgress.done();
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const UpdateVMExtraSettingConfigHelper = async (params) => {
  toast.info("Saving...");
  return await axiosInstance(`/visitors/updateVMExtraSettingConfig`, {
    method: "PUT",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      id_proof: params?.id_proof || false,
      user_id: getUserId(),
      vehicle_no: params?.vehicle_no || false,
      is_canteen_token_applicable: params?.is_canteen_token_applicable || false,
      is_inout_qr_applicable: params?.is_inout_qr_applicable || false,
      employee_approval_required: params?.employee_approval_required || false,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Configuration updated successfully");
      return {
        message: "Configuration Updated Successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};